import { base64Decode, base64Encode, isBase64 } from '@/utils/base64';
import { Assignment } from './Assignment';
import { GradeRisk } from './GradeRisk';
import { Item } from './Item';
import { Person } from './Person';
import { Question } from './Question';

export interface UnsavedPromptDiscussion {
  aiRiskScore: number;
  aiRiskComment: string;
  plagiarismRiskScore: number;
  plagiarismRiskComment: string;
  accuracyScore: number;
  accuracyRiskComment: string;
}

export interface UnsavedPrompt extends Item {
  assignmentId: number;
  assignment?: Assignment;
  personId: number;
  person?: Person;
  questionId: number;
  question?: Question;
  prompt: string;

  isFlagged: boolean;
  flagComment: string;

  aiMisuseRisk?: GradeRisk;
  plagiarismRisk?: GradeRisk;
  accuracyRisk?: GradeRisk;

  discussions?: UnsavedPromptDiscussion;
}

export const translateUnsavedPromptFromTransport = (attributes: UnsavedPrompt) => {
  return {
    ...attributes,
    prompt: isBase64(attributes.prompt) ? base64Decode(attributes.prompt) : attributes.prompt,
  };
};

export const translateUnsavedPromptForTransport = (attributes: UnsavedPrompt) => {
  return {
    ...attributes,
    prompt: !isBase64(attributes.prompt) ? base64Encode(attributes.prompt) : attributes.prompt,
  };
};
